import { userReviews } from '@/mocks/reviews';

export default function ReviewsSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">
            用户真实评价
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            来自不同行业用户的真实使用反馈，了解91c在实际场景中的价值
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {userReviews.slice(0, 3).map((review) => (
            <div
              key={review.name}
              className="p-5 bg-background-50 rounded-lg border border-background-200"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-xs ${i < review.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-200'}`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                &ldquo;{review.content}&rdquo;
              </p>
              <div className="mt-4 flex items-center gap-3">
                <img
                  src={review.avatar}
                  alt={review.name}
                  className="w-10 h-10 rounded-full object-cover"
                  width="40"
                  height="40"
                />
                <div>
                  <p className="text-sm font-medium text-foreground-900">{review.name}</p>
                  <p className="text-xs text-foreground-400">
                    {review.role}，{review.company}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}